import CloseIcon from "@mui/icons-material/Close";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const AcceptConfirmationDialog = ({
  open,
  onClose,
  selectedVendor,
  selectedCategory,
  isMobile,
}) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const dialogStyle = {
    "& .MuiDialog-paper": {
      width: isMobile ? "100vw" : isTablet ? "80vw" : "min(360px, 85vw)",
      maxWidth: isMobile ? "none" : "500px",
      borderRadius: isMobile ? 0 : "8px",
      p: { xs: 2, sm: 2.5 },
      maxHeight: isMobile ? "90vh" : "75vh",
      margin: isMobile ? 0 : "24px",
      bgcolor: "background.paper",
      boxShadow: isMobile ? 0 : 24,
      "& .MuiDialogContent-root": {
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
        "&::-webkit-scrollbar": {
          width: "8px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "grey.400",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "grey.100",
        },
      },
    },
  };

  return (
    <Dialog open={open} onClose={onClose} sx={dialogStyle}>
      {isMobile && (
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "grey.500",
            bgcolor: "grey.100",
            "&:hover": { bgcolor: "grey.200" },
            borderRadius: "50%",
            p: 0.8,
            zIndex: 1,
          }}
          aria-label="Close dialog"
        >
          <CloseIcon sx={{ fontSize: { xs: "1.2rem", sm: "1.4rem" } }} />
        </IconButton>
      )}
      <DialogTitle
        sx={{
          fontSize: { xs: "1.1rem", sm: "1.2rem" },
          fontWeight: 600,
          pr: isMobile ? 4 : 0,
          pb: 1,
        }}
      >
        Thank you
      </DialogTitle>
      <DialogContent sx={{ py: { xs: 0.5, sm: 0.75 } }}>
        <Typography
          sx={{
            fontSize: { xs: "0.75rem", sm: "0.8rem" },
            lineHeight: 1.4,
          }}
        >
          A consultant from {selectedVendor?.name} will be contacting you soon
          to discuss your{" "}
          {selectedCategory ? selectedCategory.replace(/-/g, " ") : "insurance"}{" "}
          quote.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: isMobile ? "center" : "flex-end" }}>
        <Button
          onClick={onClose}
          color="primary"
          sx={{
            fontSize: { xs: "0.75rem", sm: "0.8rem" },
            py: { xs: 0.8, sm: 1 },
            px: { xs: 1.5, sm: 2 },
            borderRadius: "6px",
            textTransform: "none",
            fontWeight: 500,
            color: "#fff",
            bgcolor: "primary.main",
            "&:hover": { bgcolor: "primary.dark" },
            boxShadow: "none",
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AcceptConfirmationDialog;